<template>
    <div class="flex-1 d-flex flex-column h-100">
        <div class="flex-1 d-flex flex-column overflow-auto p-4">
            <div class="row align-items-start m-2 gap-2" style="flex: unset">
                <v-btn style="height: auto !important" text color="primary" class="p-0 btn-color-2" @click="openAddSignatureDialog()" v-if="this.userHavePinCode">
                    <v-icon>custom-icon mdi-primary-plus-ring</v-icon>{{$t("res_Lable_AddSignature")}}
                </v-btn>
                <label v-else style="color: red">
                    {{ $t("res_Msgs_ManageSignatures") }}
                </label>
            </div>
            <v-data-table :mobile-breakpoint="0" class="d-flex flex-column flex-1 order-table" hide-default-footer disable-sort
                :headers="signatureheaders" :items-per-page="10" :items="userSignature.selectedSignatures"
                :loading="loading" loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
                :footer-props="{ 'items-per-page-text': 'Items per page' }" caption=""
                :class="{ 'result_available': userSignature.selectedSignatures.length != 0, 'no-data': userSignature.selectedSignatures.length == 0 }" header-fixed
                fixed-header>
                <template v-slot:item="row" item-key="id">
                    <tr>
                        <td style="display: none">{{ row.item.id }}</td>
                        <td><img id="ItemPreview" :src=row.item.thumbnail></td>
                        <td>{{ row.item.name }}</td>
                        <td>{{ row.item.isDefault }}</td>
                        <td>
                            <div class="onhover-display">
                                <div class="custom-icon-wrapper ma-2">
                                    <v-icon @click="openResizeSignatureDialog(row.item)">mdi-move-resize</v-icon>
                                </div> 
                                <div class="custom-icon-wrapper ma-2">
                                    <v-icon @click="getUserSignature(row.item.id)">custom-icon white-bg edit-icon</v-icon>
                                </div>
                                <div class="custom-icon-wrapper ma-2">
                                    <v-icon @click="deleteUserSignature(row.item.id)">custom-icon white-bg delete-icon</v-icon>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-slot:no-data>
                    <v-row class="p-5">
                        <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                        <p class="m-0">{{ $t("res_Msgs_AlertNoItemsHere") }}</p>
                    </v-row>
                </template>
            </v-data-table>
        </div>

        <v-card-actions class="gap-2 sticky-actions">
            <v-spacer></v-spacer>
            <v-btn class="light-blue" style="min-width: 100px !important;" @click="close()">{{$t("res_ButtonText_Cancel")}}</v-btn>
        </v-card-actions>

        <v-dialog v-model="showAddSignatureDialog" width="25%" height="30%">
            <v-card>
                <v-card-title v-if="current_action=='new'">
                    {{ $t("res_Label_AddSignature") }}
                </v-card-title>
                <v-card-title v-if="current_action=='edit'">
                    {{ $t("res_Label_EditSignature") }}
                </v-card-title>
                <v-card-text>
                    <v-row class="my-3 ml-0">
                        <v-col>
                            <label>{{ $t("res_Label_SignatureName") }} <span style="color: red"> *</span></label>
                            <v-text-field solo v-model="userSignature.signatureName"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row  class="my-3 ml-0">
                        <v-col>
                            <v-radio-group inline v-model="signature_method" row id="addSignatureRadio">
                                <v-radio color="#00ae8d" v-bind:label=" $t('res_Radio_Image')" value="1" ></v-radio>
                                <v-radio color="#00ae8d" v-bind:label=" $t('res_Radio_Draw')" value="2"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row class="my-3 ml-0" v-show="signature_method=='1'">
                        <v-col>
                            <label>{{ $t("res_Label_AttachSignature") }} <span style="color: red"> *</span> </label>
                            <v-file-input id="input-file" accept="image/*" label="" solo v-model="userSignature.signatureFile" @click="showTempCanvas=true"  
                                @change="removeBackgroundColorOnAdd()" :rules="this.userSignature.uploadDocument">
                            </v-file-input>
                            <canvas id="signatureCanvas" v-if="showTempCanvas==true"></canvas>
                        </v-col>
                    </v-row>
                    <v-row class="my-3 ml-0" v-show="signature_method=='2'">
                        <v-col id="signature_div">
                            <label>{{ $t("res_Label_DrawSignature") }} <span style="color: red"> *</span></label>

                            <VueSignaturePad id="signatureModel" width="100%" height="200px" ref="signaturePad" :options="optionsPad" />

                            <vue-cropper class="cropper-SM " id="cropper-SM" ref="cropperSM" :img="option.img" :output-size="option.size" 
                                :output-type="option.outputType" :info="true" :full="option.full" :fixed="fixed" :fixed-number="fixedNumber"
                                :can-move="option.canMove" :can-move-box="option.canMoveBox" :fixed-box="option.fixedBox" :auto-crop="option.autoCrop" 
                                :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight" :center-box="option.centerBox"
                                @real-time="realTime" :high="option.high" @img-load="imgLoad" mode="cover" :max-img-size="option.max" 
                                @crop-moving="cropMoving"></vue-cropper>

                            <div> 
                                <img id='image-to-crop-SM'/>
                            </div>

                            <v-spacer></v-spacer>
                            <v-btn width="100" id="crop-btn-SM" class="primary white--text mt-4" @click="convertToImage()">{{$t("res_ButtonText_Crop")}}</v-btn>
                            <v-btn width="100" id="done-btn-SM" class="primary white--text mt-4 " @click="finish2()">{{$t("res_ButtonText_Done")}}</v-btn>              
                            <v-btn width="100" id="clear-btn-SM" class="primary white--text mt-4 ml-4 " @click="resetCanvas()">{{$t("res_ButtonText_Clear")}}</v-btn> 
                        </v-col>
                    </v-row>

                    <v-row class="my-3 ml-0">
                        <v-checkbox v-model="userSignature.isDefault" color="#00ae8d" :label='$t("res_Label_IsDefault")'></v-checkbox>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="white" width="100" class="black--text" @click="showAddSignatureDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>

                    <v-btn width="100" v-if="current_action=='new'" class="primary white--text" @click="addUserSignature()">{{$t("res_ButtonText_Submit")}}</v-btn>
                    <v-btn width="100" v-if="current_action=='edit'" class="primary white--text" @click="editUserSignature()">{{$t("res_ButtonText_Submit")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="EditSignatureDialog" width="25%" height="30%">
            <v-card>
                <v-card-title>
                    {{ $t("res_Label_EditSignature") }}
                </v-card-title>
                <v-card-text>
                    <v-row class="my-3 ml-3">
                        <v-col>
                            <label>{{ $t("res_Label_SignatureName") }} <span style="color: red"> *</span></label>
                            <v-text-field solo v-model="editSignature.signatureName"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row  class="my-3 ml-3">
                        <v-col>
                            <v-radio-group inline v-model="signature_method" row>
                                <v-radio color="#00ae8d" v-bind:label=" $t('res_Radio_Image')" value="1" ></v-radio>
                                <v-radio color="#00ae8d" v-bind:label=" $t('res_Radio_Draw')" value="2"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row class="my-3 ml-3" v-if="signature_method=='1'">
                        <v-col>
                            <label>{{ $t("res_Label_AttachSignature") }} </label>
                            <v-file-input id="input-file" accept="image/*" label="" solo v-model="editSignature.signatureFile"
                                :rules="this.editSignature.uploadDocument">
                            </v-file-input>
                        </v-col>
                    </v-row>
                    
                    <v-row class="my-3 ml-3" v-if="signature_method=='2'">
                        <v-col>
                            <label>{{ $t("res_Label_DrawSignature") }} <span style="color: red"> *</span></label>
                            
                            <VueSignaturePad id="signatureModel2" width="100%" height="200px" ref="signaturePad" :options="optionsPad" />
                            
                            <vue-cropper class="cropper-SM " id="cropper-SM2" ref="cropperSM" :img="option.img" :output-size="option.size" 
                            :output-type="option.outputType" :info="true" :full="option.full" :fixed="fixed" :fixed-number="fixedNumber" 
                            :can-move="option.canMove" :can-move-box="option.canMoveBox" :fixed-box="option.fixedBox" :auto-crop="option.autoCrop" 
                            :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight" :center-box="option.centerBox"
                            @real-time="realTime" :high="option.high" @img-load="imgLoad" mode="cover" :max-img-size="option.max" 
                            @crop-moving="cropMoving"></vue-cropper>

                            <div><img id='image-to-crop-SM2' /></div>

                            <v-spacer></v-spacer>
                            <v-btn width="100" id="crop-btn-SM2" class="primary white--text mt-4" @click="convertToImage()">{{$t("res_ButtonText_Crop")}}</v-btn>
                            <v-btn width="100" id="done-btn-SM2" class="primary white--text mt-4 " @click="finish2()">{{$t("res_ButtonText_Done")}}</v-btn>              
                            <v-btn width="100" id="clear-btn-SM2" class="primary white--text mt-4 ml-4 " @click="resetCanvas()">{{$t("res_ButtonText_Clear")}}</v-btn> 
                        </v-col>
                    </v-row>
                    <v-row class="my-3 ml-3">
                        <v-checkbox v-model="editSignature.isDefault" color="#00ae8d" :label='$t("res_Label_IsDefault")'></v-checkbox>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="white" width="100" class="black--text" @click="EditSignatureDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                    <v-btn width="100" class="primary white--text" @click="editUserSignature()">{{$t("res_ButtonText_Submit")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

         <v-dialog v-model="resizeSignatureDialog" width="75%" height="50%">
            <v-card>
                <v-card-title>
                    {{$t('res_Label_ResizeSignature')}} 
                </v-card-title>
                <v-card-text class="pb-0" v-if="!showResizeSignatureSkeleton">
                    <v-row>
                        <v-col cols="12" class="mt-4"> 
                            <label>{{$t('res_Label_MaintainAspectRatio')}} </label>
                            <v-checkbox v-model="resizeSignature.maintainAspectRatio" class="pt-2"></v-checkbox>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                     <label>{{$t('res_Label_Width')}}</label>
                            <v-text-field solo type="number" @input="updateResizeSignatureHeight"  v-model="resizeSignature.width"></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                         <label>{{$t('res_Label_Height')}}</label>
                            <v-text-field solo type="number" @input="updateResizeSignatureWidth" v-model="resizeSignature.height"></v-text-field>
                        </v-col>
                    </v-row> 
                     <v-row class="p-0 m-1">
                        <v-col class="text-center m-auto" style="max-width: 1100px;max-height: 315px;overflow: auto;border-radius: 17px;">
                            <img class="border rounded shadow-sm" :width="resizeSignature.width" :height="resizeSignature.height"  style="object-fit:contain" ref="image" :src=resizeSignature.signature />
                        </v-col>
                    </v-row>
                </v-card-text>

				<v-card-text class="pb-0" v-if="showResizeSignatureSkeleton">
                    <v-row>
                        <v-col cols="12" class="mt-4">
                            <label>{{$t('res_Label_MaintainAspectRatio')}} </label>
                            <v-checkbox v-model="resizeSignature.maintainAspectRatio" class="pt-2"></v-checkbox>
                        </v-col> 
                        <v-col cols="6" class="pt-0 ResizeElements">
                            <label>{{$t('res_Label_Width')}}</label>
                           <v-skeleton-loader  type="text"></v-skeleton-loader>
                        </v-col>
                        <v-col cols="6" class="pt-0 ResizeElements"> 
							<label>{{$t('res_Label_Height')}}</label>
                            <v-skeleton-loader  type="text"></v-skeleton-loader>
                        </v-col>
                    </v-row> 
                     <v-row class="p-0 m-1">
                        <v-col class="text-center m-auto ResizeImage" style="max-width: 1100px;max-height: 315px;overflow: auto;border-radius: 17px;">
                            <v-skeleton-loader  type="text"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="mt-4">
                    <v-spacer></v-spacer>
                    <v-btn color="white" width="100" class="black--text" @click="resizeSignatureDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                    <v-btn width="100" class="primary white--text" @click="updateUserSignatureImageSize()">{{$t("res_ButtonText_Submit")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> 
    </div>
</template>
   
<script>
    import axios from 'axios';
    import router from '@/router/index.js'
    import constants from '@/assets/js/constants'
    import MultiSelect from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'UserSignatureManager',
        components: { MultiSelect },
        props: {
            userid: { type: Number, default: 0 },
            dialogModelShow: { type: Boolean, default: false },
        },
        data: function () {
            return {	
                signatureWidth: 0,
			    signatureHeight: 0, 
			    showResizeSignatureSkeleton: true,
                userHavePinCode: false,      
                edit_image: '',
                showTempCanvas: true,
                signature_method: '1',
                current_action: 'new',
                optionsPad: {
                    dotSize: (0.5 + 2.5) / 2,
                    minWidth: 0.5,
                    maxWidth: 2.5,
                    throttle: 16,
                    minDistance: 5,
                    backgroundColor: 'rgba(0,0,0,0)',
                    penColor: 'black',
                    velocityFilterWeight: 0.7,
                    onBegin: () => 
                    {
                        if (this.$refs.signaturePad)
                            this.$refs.signaturePad.resizeCanvas()
                    },
                    onEnd: () => {}
                },
                model: false,
                modelSrc: '',
                crap: false,
                previews: {},
                imageFile: null,
                lists: [{ img: '' }],
                option: {
                    img: '',
                    size: 1,
                    full: false,
                    outputType: 'png',
                    canMove: true,
                    fixedBox: false,
                    original: false,
                    canMoveBox: true,
                    autoCrop: true,
                    autoCropWidth: 750,
                    autoCropHeight: 340,
                    centerBox: true,
                    high: true,
                    max: 99999
                },
                show: true,
                fixed: false,
                fixedNumber: [16, 9],
                loading: false,
                search_query: '',
                companyId: null,
                user_items: [],
                company_items: [],
                userId: 0,
                manageApplicationRoleDialog: false,
                options: ['list', 'of', 'options'],
                headers: [
                    { text: this.$t("res_GridHeaders_Name"), value: 'name' },
                    { text: this.$t("res_GridHeaders_NameAr"), value: 'nameAr' },
                    { text: this.$t("res_GridHeaders_Email"), value: 'email' },
                    { text: this.$t("res_GridHeaders_Structure"), value: 'parentName' },
                    { text: '', value: 'actions', sortable: false, width: '190px' },
                ],
                changePinCodeDialog: false,
                changeUserPasswordDialog: false,
                showAddSignatureDialog: false,
                EditSignatureDialog: false,
                manageUserSignaturesDialog: false,
                signatureheaders: [
                    { text: 'Id', value: 'id', sortable: false, align: ' d-none' },
                    { text: this.$t("res_GridHeaders_Image"), value: 'thumbnail', sortable: false, width: '20%' },
                    { text: this.$t("res_GridHeaders_SignatureName"), value: 'name', sortable: false, width: '20%' },
                    { text: this.$t("res_GridHeaders_DefaultSignature"), value: 'isDefault', sortable: false, width: '20%' },
                    { text: '', value: '', sortable: false, width: '40%' },
                ],
                userSignature: {
                    selectedSignatures: [],
                    signatureName: '',
                    signatureFile: {},
                    isDefault: false,
                    uploadDocument: [ value => !!value || 'Please upload signature' ],
                },
                editSignature: {
                    Id: 0,
                    signatureName: '',
                    signatureFile: {},
                    isDefault: false,
                    uploadDocument: [ value => !!value || 'Please upload signature' ],
                },
                resizeSignature: { id: 0, width: 0, height: 0, signature: '', maintainAspectRatio: true, originalWidth: 0, originalHeight: 0 },
                resizeSignatureDialog: false,
                aspectRatioSynchronizing: false,
                client_version_Id: constants.client_version_Id,
                tempSignature : null
            }
        },
        watch: {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                        this.getUserSinatures()
                }
            },
            signature_method(newValue, oldValue)
            {
                if (newValue=='2'&& this.current_action=='edit' )
                {
                    window.showLoading();
                    setTimeout(()=>
                    {
                        this.$refs.signaturePad.resizeCanvas();
                        this.getSignature();
                        this.$refs.signaturePad.fromDataURL(this.canvasBase64)
                        window.hideLoading()
                    },"1000")
                }
            },
            EditSignatureDialog(newValue,oldValue)
            {
                if (newValue == false)
                {
                    var imgtocrop2=document.getElementById('image-to-crop-SM2');
                    var signatureModel2=document.getElementById('signatureModel2');
                    var cropperSM=document.getElementById('cropper-SM2');
                    const cropBtn = document.getElementById('crop-btn-SM2')
                    const clearBtn =document.getElementById('clear-btn-SM2')
                    const doneBtn = document.getElementById('done-btn-SM2');
                    imgtocrop2.style.display='none';
                    signatureModel2.style.display='block';
                    this.userSignature.signatureFile={};
                    this.userSignature.signatureName="";
                    if(cropperSM&&cropperSM.style.display=='block'){
                        cropperSM.style.display='none';
                    }
                    if(cropBtn&&cropBtn.style.display=='none'){
                        cropBtn.style.display='inline';
                    }
                    if(clearBtn&&clearBtn.style.display=='none'){
                        clearBtn.style.display='inline';
                    }
                    if(doneBtn&&doneBtn.style.display=='block'){
                        doneBtn.style.display='none';
                    }
                    this.resetCanvas();this.signature_method="1";
                }
            },
            showAddSignatureDialog(newValue,oldValue)
            {
                if (newValue == false)
                {
                    var imgtocrop1=document.getElementById('image-to-crop-SM');
                    var signatureModel=document.getElementById('signatureModel');
                    var cropperSM=document.getElementById('cropper-SM');
                    const cropBtn = document.getElementById('crop-btn-SM')
                    const clearBtn =document.getElementById('clear-btn-SM')
                    const doneBtn = document.getElementById('done-btn-SM');
                    imgtocrop1.style.display='none';
                    signatureModel.style.display='block';
                    this.userSignature.signatureFile={};
                    this.userSignature.signatureName="";
                    if(cropperSM&&cropperSM.style.display=='block'){
                        cropperSM.style.display='none';
                    }
                    if(cropBtn&&cropBtn.style.display=='none'){
                        cropBtn.style.display='inline';
                    }
                    if(clearBtn&&clearBtn.style.display=='none'){
                        clearBtn.style.display='inline';
                    }
                    if(doneBtn&&doneBtn.style.display=='block'){
                        doneBtn.style.display='none';
                    }
                    this.resetCanvas();this.signature_method="1";
                }
            }, 
        },
        methods:
        {   
            async updateUserSignatureImageSize() {
                let isFormValid = true;
                isFormValid =
                    this.resizeSignature.height > 0 &&
                    this.resizeSignature.width > 0 &&
                    this.resizeSignature.id > 0;
                if (isFormValid == false) {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }
                try { 
                    const response =
                        await axios.put(`${constants.baseApiUrl}Admin/UpdateUserSignatureImageSize?signatureId=${this.resizeSignature.id}&width=${parseInt(this.resizeSignature.width)}&height=${parseInt(this.resizeSignature.height)}`);
                    if (response.data.success == true) {
                        window.showAlert(
                            this.$t("res_Msgs_SuccessfulSave"),
                            "success"
                        );
                        this.resizeSignatureDialog = false; 
                        this.getUserSinatures();
                    }
                } catch (error) {
                    console.error(error);
                }
		    }  
		    ,
           	async fetchOriginalWidth_Height(file) {
                return new Promise((resolve, reject) => {
                    if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const img = new Image();
                        img.src = e.target.result;
                        img.onload = () => {
                        const width = img.width;
                        const height = img.height;
                        resolve({ "width":width,"height":height });
                        };
                    };
                    reader.readAsDataURL(file);
                    } else {
                    reject("File not provided");
                    }
                });
			},
            close()
            {
                this.$emit('closeDialog')
            },
            async removeBackgroundColorOnAdd()
            {
                let MainImage = await this.fetchOriginalWidth_Height(this.userSignature.signatureFile); 
                if (this.userSignature.signatureFile && this.userSignature.signatureFile !=null && this.userSignature.signatureFile!= undefined)
                {
                    this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                        window.showLoading();
                        var array = fileBytes,
                        imgData = fileBytes;
                        const canvas=document.getElementById('signatureCanvas');
                        canvas.width = MainImage.width;
				        canvas.height = MainImage.height;
                        //draw image
                        var ctx = canvas.getContext("2d");
                        var uInt8Array = imgData;
                        var i = uInt8Array.length;
                        var binaryString = [i];
                        while (i--) {
                            binaryString[i] = String.fromCharCode(uInt8Array[i]);
                        }
                        var data = binaryString.join('');
                        var base64 = window.btoa(data);
                        var img = new Image();
                        img.src = "data:image/png;base64," + base64;
                        img.onload =  () => 
                        {
                            ctx.drawImage(img,0, 0, canvas.width, canvas.height);
                            var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height),
                                pix = imgd.data,
                            newColor = {r:0,g:0,b:0, a:0};
                            for (var i = 0, n = pix.length; i <n; i += 4) {
                                var r = pix[i],
                                        g = pix[i+1],
                                        b = pix[i+2];
                                    if(r == 255&& g == 255 && b == 255){ 
                                        // Change the white to the new color.
                                        pix[i] = newColor.r;
                                        pix[i+1] = newColor.g;
                                        pix[i+2] = newColor.b;
                                        pix[i+3] = newColor.a;
                                    }
                            }
                            ctx.putImageData(imgd, 0, 0);
                            const image = new Image();
                            image.src = canvas.toDataURL();
                            this.ConvertClick(image.src);
                            canvas.style.height="0px";
                            window.hideLoading()
                        }; 
                    })
                }
            },
            removeImageWhiteBg()
            {
                const canvasDiv =  document.getElementById('signatureModel')
                const canvas = canvasDiv.getElementsByTagName('canvas')[0];
                const ctx = canvas.getContext('2d');
                var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height), pix = imgd.data, newColor = {r:0,g:0,b:0, a:0};
                for (var i = 0, n = pix.length; i <n; i += 4) 
                {
                    var r = pix[i], g = pix[i+1], b = pix[i+2];
                    if(r == 255&& g == 255 && b == 255)
                    { 
                        // Change the white to the new color.
                        pix[i] = newColor.r;
                        pix[i+1] = newColor.g;
                        pix[i+2] = newColor.b;
                        pix[i+3] = newColor.a;
                    }
                }
                ctx.putImageData(imgd, 0, 0);
            },
            getSignature()
            {
                let self = this;
                self.$refs.signaturePad.fromDataURL(this.canvasBase64);
                this.$refs.signaturePad.fromDataURL(this.canvasBase64);

                const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
                    const byteCharacters = atob(b64Data);
                    const byteArrays = [];
                    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        const slice = byteCharacters.slice(offset, offset + sliceSize);
                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }
                    const blob = new Blob(byteArrays, {type: contentType});
                    return blob;
                }
                const contentType = 'image/png';
                const b64Data = this.canvasBase64.replace('data:image/png;base64,','');
                const blob = b64toBlob(b64Data, contentType);
                const blobUrl = URL.createObjectURL(blob);
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => 
                {
                    self.$refs.signaturePad.fromDataURL(reader.result);
                    this.$refs.signaturePad.fromDataURL(reader.result);
                }
            },
            //crop methods
            changeImg() {
                this.option.img = this.lists[~~(Math.random() * this.lists.length)].img
            },
            startCrop() {
                // start
                this.crap = true
                this.$refs.cropperSM.startCrop()
            },
            stopCrop() {
                //  stop
                this.crap = false
                this.$refs.cropperSM.stopCrop()
            },
            clearCrop() {
                // clear
                this.$refs.cropperSM.clearCrop()
            },
            refreshCrop() {
                // clear
                this.$refs.cropperSM.refresh()
            },
            changeScale(num) {
                num = num || 1
                this.$refs.cropperSM.changeScale(num)
            },
            rotateLeft() {
                this.$refs.cropperSM.rotateLeft()
            },
            rotateRight() {
                this.$refs.cropperSM.rotateRight()
            },
            finish(type) {
            
                if (type === 'blob') {
                this.$refs.cropperSM.getCropBlob((data) => {
                    var img = window.URL.createObjectURL(data)
                    this.model = true
                    this.modelSrc = img
                })
                } 
                else 
                {
                    this.$refs.cropperSM.getCropData((data) => {
                        this.model = true
                        this.modelSrc = data
                    })
                }
            },
            realTime(data) 
            {
                this.previews = data;
            },
            finish2(type) 
            {
                this.$refs.cropperSM.getCropData((data) => {
                    this.model = true
                    this.modelSrc = data;
                    var itc=document.getElementById('image-to-crop-SM')
                    itc.src=data
                    itc.style.display='block'
                    var cr=document.getElementById('cropper-SM')
                    cr.style.display='none'
                    var doneBtn= document.getElementById('done-btn-SM')
                    doneBtn.style.display='none'
                    this.ConvertClick(data);
                })
            },
            finish3(type) {
                this.$refs.cropperSM3.getCropData((data) => {
                    this.model = true
                    this.modelSrc = data
                })
            },
            down(type) {
                // event.preventDefault()
                var aLink = document.createElement('a')
                aLink.download = 'demo'
                if (type === 'blob') {
                    this.$refs.cropperSM.getCropBlob((data) => {
                        this.downImg = window.URL.createObjectURL(data)
                        aLink.href = window.URL.createObjectURL(data)
                        aLink.click()
                    })
                } else {
                    this.$refs.cropperSM.getCropData((data) => {
                        this.downImg = data
                        aLink.href = data
                        aLink.click()
                    })
                }
            },
            uploadImg(e, num) 
            {
                var file = e.target.files[0]
                if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) 
                {
                    return false
                }

                var reader = new FileReader()
                reader.onload = (e) => {
                    let data
                    if (typeof e.target.result === 'object') {
                        data = window.URL.createObjectURL(new Blob([e.target.result]))
                    } 
                    else 
                    {
                        data = e.target.result
                    }
                    if (num === 1) {
                        this.option.img = data
                    } else if (num === 2) {
                        this.example2.img = data
                    }
                }
                reader.readAsArrayBuffer(file)
            },
            imgLoad(msg) 
            {
            },
            cropMoving(data) 
            {
            },
            //canvas signature methods
            convertToImage2()
            {
                const canvasDiv = document.getElementById('signatureModel')
                const canvas = canvasDiv.getElementsByTagName('canvas')[0];
                const context = canvas.getContext('2d');
                // Create an image element
                const image = new Image();
                // Assign the canvas content as the source of the image
                image.src = canvas.toDataURL();
                this.option.img = image.src;
                this.ConvertClick(image.src);
            },
            convertToImage() {
                this.removeImageWhiteBg();
                // Get the canvas element
                const canvasDiv = document.getElementById('signatureModel')
                const canvas = canvasDiv.getElementsByTagName('canvas')[0];
                const context = canvas.getContext('2d');
                // Create an image element
                const image = new Image();
                // Assign the canvas content as the source of the image
                image.src = canvas.toDataURL();
                const imageObject = document.getElementById('image-to-crop-SM')
                const doneBtn = document.getElementById('done-btn-SM')
                const cropBtn = document.getElementById('crop-btn-SM')
                const clearBtn =document.getElementById('clear-btn-SM')
                const cropper =document.getElementById('cropper-SM')
                cropper.style.display = "block";
                cropBtn.style.display = "none";
                canvasDiv.style.display = "none";
                clearBtn.style.display = "none";
                doneBtn.style.display = "block";
                imageObject.src = '';
                this.option.img = image.src;
                this.ConvertClick(image.src);
            },
            undo() {
                this.$refs.signaturePad.fromData([]);
            },
            save() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            },
            change() 
            {
                this.options = { penColor: "#00f" };
            },
            resume() 
            {
                this.options = { penColor: "#c0f" };
            },
            backToAdminPage()
            {
                router.push({ name: 'admin' })
            },
            clearFields() 
            {
                this.search_query = ''
                this.companyId = {}
            },
            changeUserActivationStatus(_userId) 
            {
                window.showLoading()
                axios.get(constants.baseApiUrl + "Admin/ToggleUserActivationStatus?userId=" + _userId)
                    .then((res) => 
                    {
                        if(res != null && res != undefined)
                        this.user_items.find(x=>x.userId == _userId).active =res.data
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            manageUserSignatures(id) 
            {
                this.userId = id;
            },
            getUserSinatures() 
            {
                this.userSignature.selectedSignatures = []
                var user = JSON.parse(sessionStorage.getItem("user"));
                this.userId = this.userid;

                axios.get(constants.baseApiUrl + "Admin/DoesUserHavePinCode?userId=" + this.userId)
                    .then((res) => {
                        this.userHavePinCode = res.data
                    })
                    .catch((err) => { console.warn(err); });

                axios.get(constants.baseApiUrl + 'Admin/GetUserSignatures?userId=' + this.userId)
                    .then(response => {
                        if (response.data != null) {
                            response.data.forEach((item) => {
                                var signatureBody = {
                                    id: item.id,
                                    name: item.name,
                                    isDefault: item.isDefault,
                                    thumbnail: "data:image/png;base64," + item.thumbnail
                                }
                                this.userSignature.selectedSignatures.push(signatureBody)
                            });
                        }
                        this.manageUserSignaturesDialog = true
                    })
                    .catch((err) => { console.warn(err); window.showAlert(err, 'error'); });
            },
            resetCanvas () 
            {
                this.undo();
            },
            openAddSignatureDialog() {
                this.current_action='new';
                this.showAddSignatureDialog = true;
            },
            dataURLtoFile(dataurl, filename) 
            {
                var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, { type: mime });
            },
            ConvertClick(base64url) {
                var extension=new Date().getTime();
                var file = this.dataURLtoFile(base64url, String("signature"+extension+".png"));
                let container = new DataTransfer();
                container.items.add(file);
                var input=document.createElement('input');
                input.type="file";
                input.id='input-file'
                input.files=container.files;
                var newfile =input.files[0];
           
                this.userSignature.signatureFile=newfile;
           
                this.imageFile=this.base64ToArrayBuffer(base64url.split('data:image/png;base64,')[1]);
            },
            base64ToArrayBuffer(base64) {
                var binaryString = atob(base64);
                var bytes = new Uint8Array(binaryString.length);
                for (var i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                return bytes.buffer;
            },
            addUserSignature() 
            {
                if (!this.userSignature.signatureFile.size || !this.userSignature.signatureName.trim()) {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }

                if (this.signature_method=='2')
                {
                    this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                        var signatureBody = {
                            SignatureUserId: this.userId,
                            SignaturePin: this.userSignature.signaturePin,
                            SignatureBytes: fileBytes,
                            SignatureName: this.userSignature.signatureName,
                            IsDefault: this.userSignature.isDefault
                        }

                    axios.post(constants.baseApiUrl + 'Admin/AddUserSignature', signatureBody)
                        .then(response => {
                            if (response.data) {
                                this.getUserSinatures()
                                this.showAddSignatureDialog = false
                                this.userSignature.signatureFile = {}
                                this.userSignature.signatureName = ''
                                this.userSignature.isDefault = false
                                window.showAlert(this.$t("res_Msgs_SignatureAddedSuccess"), 'success')
                            }
                            else
                                window.showAlert(this.$t("res_general_error"), 'error')
                        })
                        .catch(err => console.warn(err))
                    });
                }
                else
                {
                    this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                        var signatureBody = {
                            SignatureUserId: this.userId,
                            SignaturePin: this.userSignature.signaturePin,
                            SignatureBytes: fileBytes,
                            SignatureName: this.userSignature.signatureName,
                            IsDefault: this.userSignature.isDefault
                        }

                        axios.post(constants.baseApiUrl + 'Admin/AddUserSignature', signatureBody)
                            .then(response => {
                                if (response.data) {
                                    this.getUserSinatures()
                                    this.showAddSignatureDialog = false
                                    this.userSignature.signatureFile = {}
                                    this.userSignature.signatureName = ''
                                    this.userSignature.isDefault = false
                                    window.showAlert(this.$t("res_Msgs_SignatureAddedSuccess"), 'success')
                                }
                                else
                                {
                                    window.showAlert(this.$t("res_general_error"), 'error')    
                                }
                            })
                            .catch(err => console.warn(err))
                    });
                }
            },
            editUserSignature() 
            {
                if (!this.userSignature.signatureName.trim()) 
				{
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }

                if(!utils.CheckIfNullOrEmpty(this.tempSignature) && this.tempSignature.isDefault && !this.userSignature.isDefault)
                {
                    window.showAlert('res_Msgs_CannotMakeItIsNotDefault', "warning");
                    return;
                }
                
                if(this.userSignature.signatureFile.size){
                    this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                        var signatureBody = {
                            Id:this.editSignature.Id,
                            SignatureUserId: this.userId,
                            SignaturePin: this.userSignature.signaturePin,
                            SignatureBytes: fileBytes,
                            SignatureName: this.userSignature.signatureName,
                            IsDefault: this.userSignature.isDefault
                        }
                        axios.post(constants.baseApiUrl + 'Admin/EditUserSignature', signatureBody)
                            .then(response => {
                                if (response.data) {
                                    this.getUserSinatures()
                                    this.showAddSignatureDialog = false
                                    this.userSignature.signatureFile = {}
                                    this.userSignature.signatureName = ''
                                    this.userSignature.isDefault = false
                                    window.showAlert(this.$t("res_Msgs_SignatureEditedSuccess"), 'success')
                                }
                                else
                                {
                                    window.showAlert(this.$t("res_general_error"), 'error')    
                                }
                            })
                            .catch(err => console.warn(err))
                    });
                }
                else{
                      var signatureBody = {
                            Id:this.editSignature.Id,
                            SignatureUserId: this.userId,
                            SignaturePin: this.userSignature.signaturePin,
                            SignatureName: this.userSignature.signatureName,
                            IsDefault: this.userSignature.isDefault
                        }
                        axios.post(constants.baseApiUrl + 'Admin/EditUserSignature', signatureBody)
                            .then(response => {
                                if (response.data) {
                                    this.getUserSinatures()
                                    this.showAddSignatureDialog = false
                                    this.userSignature.signatureFile = {}
                                    this.userSignature.signatureName = ''
                                    this.userSignature.isDefault = false
                                    window.showAlert(this.$t("res_Msgs_SignatureEditedSuccess"), 'success')
                                }
                                else
                                {
                                    window.showAlert(this.$t("res_general_error"), 'error')    
                                }
                            })
                            .catch(err => console.warn(err))
                }
            },
            deleteUserSignature(signatureId) {
                window.showInformation('Warning', this.$t("res_Msgs_SignatureEnsureDelete"), () => {
                    axios.get(constants.baseApiUrl + 'Admin/DeleteUserSignature?signatureId=' + signatureId)
                        .then(response => {
                            if (response.data != null) {
                                this.getUserSinatures()
                                this.userSignature.SignatureDeleteDialog = false
                                window.showAlert(this.$t("res_Msgs_SignatureDeletedSuccess"), 'success')
                            }
                        })
                        .catch(err => console.warn(err))
                });
            },
            getUserSignature(signatureId) 
            {
                this.current_action='edit'
                const userSignatureObj=this.userSignature.selectedSignatures.filter((obj)=>{
                    return obj.id == signatureId;
                });

                axios.get(constants.baseApiUrl + 'Admin/GetUserSignature?signatureId=' + signatureId)
                    .then(response => {
                        if (response.data != null) 
                        {
                            this.editSignature.Id = signatureId
                            this.userSignature.signatureName = response.data.name
                            this.userSignature.signature = response.data.image
                            this.userSignature.isDefault = response.data.isDefault
                            this.userSignature.thumbnail = response.data.thumbnail
                            this.edit_image="data:image/png;base64," + response.data.image;
                            this.canvasBase64="data:image/png;base64," + response.data.image;
                            this.showAddSignatureDialog=true;
                            this.current_action="edit";
                            this.tempSignature = {...this.userSignature};
                        }
                    })
                    .catch(err => console.warn(err));  
            },
            async readFile(file, successHandler) 
            {
                var reader = new FileReader();
                var fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = function (evt) {
                    if (evt.target.readyState == FileReader.DONE) {
                        var arrayBuffer = evt.target.result,
                            array = new Uint8Array(arrayBuffer);
                        for (var i = 0; i < array.length; i++) {
                            fileByteArray.push(array[i]);
                        }
                        successHandler(fileByteArray);
                    }
                }
            },
            openResizeSignatureDialog(item) 
            {
                this.resizeSignatureDialog = true;
                    axios
                        .get(
                            constants.baseApiUrl +
                                "Admin/GetUserSignature?signatureId=" +
                                item.id
                        )
                        .then((response) => {
                            if (response.data != null) {
                                this.resizeSignature.signature =
                                    "data:image/png;base64," + response.data.image;
                                this.resizeSignature.id = item.id;  
                                this.showResizeSignatureSkeleton = false;
                            setTimeout(() => { 
                                    const img = new Image();
                                    img.src = this.$refs.image.src;
                                    img.onload = () => {
                                        this.resizeSignature.originalWidth = img.width;
                                        this.resizeSignature.originalHeight = img.height;
                                        this.resizeSignature.width = response.data.width;
                                        this.resizeSignature.height = response.data.height;
                                        this.signatureWidth = response.data.width;
                                        this.signatureHeight = response.data.height;   
                                    };  
                            }, 10);
                            }
                        })
                        .catch((err) => console.warn(err)); 
            },
            updateResizeSignatureWidth() {
                if (this.resizeSignature.maintainAspectRatio && this.aspectRatioSynchronizing == false) { 
                        this.aspectRatioSynchronizing = true;
                        this.resizeSignature.width = Math.round((this.signatureWidth * this.resizeSignature.height) / this.signatureHeight);  
                        this.aspectRatioSynchronizing = false;
                    }
                },
		    updateResizeSignatureHeight() {
                if (this.resizeSignature.maintainAspectRatio && this.aspectRatioSynchronizing == false) { 
                    this.aspectRatioSynchronizing = true;
                    this.resizeSignature.height = Math.round((this.signatureHeight * this.resizeSignature.width) / this.signatureWidth); 
                    this.aspectRatioSynchronizing = false;
                }
		    },
        },
        filters: 
        {
            limitText(text, maxSize)
            {
                if (!text) return '';
                text = text.toString();

                if (text.length <= maxSize) 
                {
                    return text;
                }

                return text.substr(0, maxSize).trim() + ' ...';
            }
        },
        mounted: function()
        {
            this.getUserSinatures();
        }
    }
</script>

<style> 
	.ResizeElements .v-skeleton-loader__text {
		height: 35px !important;
	} 
	.ResizeImage .v-skeleton-loader__text {
	    width: 600px;
		margin: auto;
		height: 200px !important;
	}
</style>

<style scoped>
    #signatureModel {
        border: double 3px transparent;
        border-radius: 5px;
        background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
        background-origin: border-box;
        background-clip: content-box, border-box;
        touch-action: auto !important;
    }
    #signatureModel2 {
        border: double 3px transparent;
        border-radius: 5px;
        background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
        background-origin: border-box;
        background-clip: content-box, border-box;
        touch-action: auto !important;
    }
    #done-btn-SM{
        display:none;
    }
    #done-btn-SM2{
        display:none;
    }
    .cropper-SM{
        display:none;
        height:200px !important;
    }
    .cropper-SM2{
        display:none;
        height:200px !important;
    }
    .container {
        width: "100%";
        padding: 8px 16px;
    }
    .buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        margin-top: 8px;
    }
    .vtooltip {
        background-color: white;
        padding: 5px;
        border-radius: 25px;
    }.report-container .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
    }
    .report_header { 
        height: 50px;
        vertical-align: middle; 
        font-weight: 500;
        font-size: 12px;
        letter-spacing: 0.015em;
        color: #667593;
    }
    .report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,  .report-container .v-data-table__wrapper table thead {
        background-color: #FFF;
        box-shadow: none;
    }
    .report-container {
        height: calc(100vh - 116px);
        display: flex;
        flex-direction: column;
        border-radius: 12px !important;
        overflow: auto;
        box-shadow: none !important;
    }
    .report-container .border-top {
        display: flex;
        flex-direction: column;
    }
    .report-container .v-toolbar {
        height: 80px !important;
        padding: 0;
    }
    .report-container .v-toolbar__content {
        height: 100% !important;
        padding: 24px !important;
    }
    img#ItemPreview {
        width: 100px;
        margin: 0.5rem 0;
    }
    .mdi-menu-down {
        filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%) hue-rotate(182deg) brightness(102%) contrast(83%) !important ;
    }.v-dialog .v-toolbar__content {
        height: 100% !IMPORTANT;
    }
    .v-input--selection-controls {
        margin-top: 0px !important; 
        padding-top: 0px !important;
    }
    #image-to-crop-SM{width:100%;height:auto !important}
    #image-to-crop-SM2{width:100%;height:auto !important}
    #cropper-SM{width:100%;height:200px !important}
    #cropper-SM2{width:100%;height:200px !important}
    #signatureModel2{
        height:200px !important;
    }
    #signatureModel{
        height:200px !important;
    }
    #signatureCanvas{
        width:100% !important;
        height:0px;
    }
    



</style> 